module.exports = __webpack_public_path__ + "media/images/result_sets/circles/6n5n9n3n-5beb8fa5c64d8203d47d472773aaefe5.svg";